(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/company-details-provider.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/company-details-provider.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  createContext = _React.createContext,
  useReducer = _React.useReducer;
const _svs$ticket_partner$c = svs.ticket_partner.companyDetails,
  reducer = _svs$ticket_partner$c.reducer,
  initializer = _svs$ticket_partner$c.initializer,
  initialState = _svs$ticket_partner$c.initialState;
const CompanyDetailsContext = createContext();
svs.ticket_partner.CompanyDetailsContext = CompanyDetailsContext;
const CompanyDetailsProvider = _ref => {
  let children = _ref.children;
  const _useReducer = useReducer(reducer, initialState, initializer),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  return React.createElement(CompanyDetailsContext.Provider, {
    value: {
      state,
      dispatch
    }
  }, children);
};
svs.ticket_partner.CompanyDetailsProvider = CompanyDetailsProvider;

 })(window);